import { render, staticRenderFns } from "./Serivce.vue?vue&type=template&id=7fffdf5d&"
import script from "./Serivce.vue?vue&type=script&lang=js&"
export * from "./Serivce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports